import { useState, type ReactElement } from 'react';
import { join, useLightContext } from 'light-component';
import { Input, Tag } from 'antd';
import { Icons } from 'zf-web-components/icons';
import { Block } from '../../../block';
import { Box } from '../../../box';
import { Button } from '../../../button';
import { useTranslation } from '../../../i18n';
import { Highlighter } from '../../component';
import styles from '../style.module.less';
import { EditScoreModal } from './editScoreModal';
import type { TextAreaProps } from './types';

export function TextAreaViewMode(props: TextAreaProps): ReactElement {
  const [t] = useTranslation();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const { emitter } = useLightContext();
  return (
    <Box className={styles.viewBox}>
      <Box className={join(styles.subject, styles.input)}>
        <Block if={props.ok != null}>
          {props.ok === true
            ? <Icons name='CheckOutlined' style={{ color: '#77C06E' }} />
            : <Icons name='CloseOutlined' style={{ color: '#F47F7F' }} />
          }
        </Block>
        <Block if={props.number != null}>{props.number}、</Block>
        <Block if={props.typeName != null}>
          <Tag color='#ff943f'>{props.typeName}</Tag>
        </Block>
        <Highlighter title={props.title} keyword={props.keyword} className={styles.title} />
        <Block if={props.realScore != null && props.score != null}>
          <span className={styles.score} style={{ color: props.ok === true ? 'inherit' : '#f47f7f' }}>
            {`(${props.realScore}/${props.score})`}
          </span>
        </Block>
        <Block if={props.editScore === true}>
          <Button
            icon='EditOutlined'
            label={t('打分')}
            onClick={() => setVisible(true)}
          />
        </Block>
      </Box>
      <Box className={join(styles.viewContent, styles.inputContent)}>
        <Input.TextArea
          className={styles.mb10}
          value={props.value}
          readOnly={true}
        />
        <Block if={props.specification != null && props.specification?.length > 0}>
          <div>{t('答案解析')}：</div>
          <div
            // 保留原有样式，不使用module
            className='ql-editors no-border'
            data-gramm='false'
            dangerouslySetInnerHTML={{ __html: props.specification ?? '' }}
          />
        </Block>
      </Box>
      <EditScoreModal
        visible={visible}
        title={props.title}
        maxScore={props.score ?? 0}
        realScore={props.realScore ?? 0}
        onCancel={() => setVisible(false)}
        loading={loading}
        onOk={async (score: number) => {
          setLoading(true);
          emitter.trigger('onShortAnswerScoreChange', {
            name: props.name,
            score,
            callBack: (result: boolean) => {
              if (result) {
                setLoading(false);
                setVisible(false);
              }
            }
          });
        }}
      />
    </Box>
  );
}
